import { render, staticRenderFns } from "./ShareApp.vue?vue&type=template&id=39c366f0&scoped=true"
import script from "./ShareApp.vue?vue&type=script&lang=js"
export * from "./ShareApp.vue?vue&type=script&lang=js"
import style0 from "./ShareApp.vue?vue&type=style&index=0&id=39c366f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c366f0",
  null
  
)

export default component.exports